/* Paleta alineada con la app (#343a40, #1f2937) */
const APP_COLORS = {
    primary: '#343a40',
    primaryDark: '#1f2937',
    secondary: '#6b7280',
    muted: '#9ca3af',
    connector: '#d1d5db',
};

export const EVENT_TYPE_COLORS = {
    INSPECTION_CREATED: APP_COLORS.primaryDark,
    TERMS_ACCEPTED: APP_COLORS.muted,
    CAPTURE_FINALIZED: APP_COLORS.primary,
    STATUS_CHANGED: APP_COLORS.secondary,
    AREA_STARTED: APP_COLORS.primary,
    AREA_APPROVED: APP_COLORS.primaryDark,
    AREA_REJECTED: APP_COLORS.primaryDark,
    AREA_REVERTED: APP_COLORS.muted,
    PHOTOS_RETURNED: APP_COLORS.secondary,
    MISSING_PHOTOS_REQUESTED: APP_COLORS.secondary,
    MISSING_PHOTOS_RESOLVED: APP_COLORS.primary,
    PHOTOS_SECTION_COMPLETED: APP_COLORS.primaryDark,
    INSPECTION_FINALIZED: APP_COLORS.primaryDark,
    INSPECTION_FORCED_REJECT: APP_COLORS.primaryDark,
    INSPECTION_AUTO_REJECT: APP_COLORS.primaryDark,
};

export const getEventColor = (event) => {
    return EVENT_TYPE_COLORS[event.type] || APP_COLORS.secondary;
};

export { APP_COLORS };
